<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <div class="kt-form w-webkit-fill-available">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">Blacklist Template</h5>
        <span class="modal-x-button" (click)="onCloseDialog()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>

      <div class="modal-body">
        <form class="row align-items-center" [formGroup]="form">
          <div class="col-12 row mb-2 pr-0">

            <div class="col-md-1 kt-form__label col-form-label">
              <label>Label:</label>
            </div>
            <div class="col-md-4 kt-form__control">
              <input type="text" class="form-control" formControlName="name" placeholder="Search"/>
            </div>

            <!-- <div class="col-md-1 kt-form__label col-form-label">
              <label>Status:</label>
            </div>
            <div class="col-md-2 kt-form__control">
              <select formControlName="status" class="form-control">
                <option value=""> All </option>
                <option [value]="i" *ngFor="let value of dropdown.statuses; let i = index">
                  {{ value }}
                </option>
              </select>
            </div> -->

          </div>
        </form>

        <div class="kt-section col-12 row d-flex justify-content-between mb-3 mt-2">
          <div class="dropdown dropdown-inline">
            <kt-search-button
              [loading]="searchBtnLoading"
              [disabledButton]="loading"
              (search)="onSubmit()">
            </kt-search-button>

            <kt-clear-button
              [loading]="clearBtnLoading"
              [disabledButton]="loading"
              (clear)="onClear()">
            </kt-clear-button>
          </div>

          <button
            *ngIf="canAddGameProviderBlacklistTemplate"
            class="btn btn-brand btn-icon-sm"
            (click)="onOpenDialog('create')">
            <i class="fas fa-plus"></i>Create
          </button>
        </div>

        <div class="table-responsive">
          <table class="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <th>Label</th>
                <th>Remarks</th>
                <!-- <th class="text-center">Status</th> -->
                <th class="text-center">Created By</th>
                <th class="text-center">Updated By</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>

            <tbody *ngIf="(items$ | async) as rows">
              <tr *ngFor="let row of rows">
                <td>{{ row.id }}</td>
                <td>{{ row.name }}</td>
                <td>{{ row.remarks }}</td>
                <!-- <td class="text-center">
                  <span
                    class="kt-badge kt-badge--inline kt-badge--pill kt-badge--wide"
                    [ngClass]="'kt-badge--' + row.status">
                    {{ status[row.status] }}
                  </span>
                </td> -->

                <td class="text-center">
                  {{ row.created_by ? row.created_by_username : '-' }}<br/>
                  <span placement="bottom" [ngbTooltip]="createdDateTime" container="body" class="text-ellipsis">
                    {{ timezoneDate(row.created_at, 'YYYY-MM-DD HH:mm') }}
                  </span>
                  <ng-template #createdDateTime>
                    {{ timezoneDate(row.created_at, 'YYYY-MM-DD HH:mm:ss') }}
                  </ng-template>
                </td>

                <td class="text-center">
                  {{ row.updated_by ? row.updated_by_username : '-' }}<br/>
                  <span placement="bottom" [ngbTooltip]="updatedDateTime" container="body" class="text-ellipsis">
                    {{ timezoneDate(row.updated_at, 'YYYY-MM-DD HH:mm') }}
                  </span>
                  <ng-template #updatedDateTime>
                    {{ timezoneDate(row.updated_at, 'YYYY-MM-DD HH:mm:ss') }}
                  </ng-template>
                </td>

                <td class="text-center">
                  <button
                    *ngIf="canViewGameProviderBlacklistTemplate && !canEditGameProviderBlacklistTemplate"
                    matTooltip="View"
                    class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"
                    (click)="onOpenDialog('view', row)">
                    <i class="fas fa-eye"></i>
                  </button>

                  <button
                    *ngIf="canEditGameProviderBlacklistTemplate"
                    matTooltip="Edit"
                    class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"
                    (click)="onOpenDialog('edit', row)">
                    <i class="fas fa-edit"></i>
                  </button>

                  <button
                    *ngIf="canDuplicateGameProviderBlacklistTemplate"
                    matTooltip="Duplicate"
                    class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"
                    (click)="onOpenDialog('duplicate', row)">
                    <i class="fas fa-copy"></i>
                  </button>
                </td>
              </tr>
            </tbody>

            <tbody shared-table-handler
              [loading]="loading"
              [dataLength]="dataLength"
              class="text-gray-600 fw-bold">
            </tbody>
          </table>
        </div>

        <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination">
          <ngb-pagination
            [pageSize]="pageSize"
            [(page)]="page"
            [maxSize]="maxSize"
            [directionLinks]="true"
            [boundaryLinks]="true"
            [rotate]="true"
            [collectionSize]="pagination?.total || 0"
            (pageChange)="onViewPageBy($event)">
          </ngb-pagination>

          <div class="kt-pagination__toolbar">
            <select (change)="onPerPage($event)" [(ngModel)]="pageSize" class="form-control kt-font-brand page-size">
              <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
            </select>
            <span class="pagination__desc">
              Showing {{pagination.from}} to {{pagination.to}} of {{ pagination.total | number : '1.0' }} records
            </span>
          </div>
        </div>
      </div>

      <div class="modal-footer"></div>
    </div>
  </div>
</div>
<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog()"></kt-swal-alert>
